import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { fetchSaleSummary, selectSaleSummary } from "../features/store/sales/sale.slice";

const useSaleSummary = () => {
    const dispatch = useAppDispatch();
    const summary = useAppSelector(selectSaleSummary);

    const getSaleSummary = async () => {
        await dispatch(fetchSaleSummary());
    }

    useEffect(() => {
        getSaleSummary();
    }, []);

    return summary;
}
 
export default useSaleSummary;